export default "__VITE_ASSET__yxPu3LZG__"